<script>
import Vue from "vue";
import "vue-tel-input/dist/vue-tel-input.css";
import image1 from "@/assets/images/instructur/1.png";
import image2 from "@/assets/images/instructur/2.png";
import image3 from "@/assets/images/instructur/3.png";
import image4 from "@/assets/images/instructur/4.png";
import image5 from "@/assets/images/instructur/5.png";
import image6 from "@/assets/images/instructur/6.png";
import Footer from "../../layouts/footer"
import Header from "../../layouts/header";

global.jQuery = require("jquery");
var $ = global.jQuery;
window.$ = $;

export default {
  components: {Header, Footer },
  data() {
    return {
      registrationPayload: {
        hp: "",
        phone_country_code: 62,
        country: "",
      },
      instructur: [
        {
          image: image1,
          nama: "Yoshua Redrie Gombo",
          text1: "Doctor of Philosophy, Controls and Robotics",
          text2: "University of Washington, Seattle",
          text3: "Chief Operating Officer, Honai Technology",
        },
        {
          image: image2,
          nama: "Insoraki Swabra",
          text1: "Master of Science, Mathematics",
          text2: "Illinois State University",
          text3: "Graduate Teaching Assistant, Illinois State University",
        },
        {
          image: image3,
          nama: "Cor Handika Sawai",
          text1: "Bachelor of Science, Cyber Security",
          text2: "LeTourneau University",
          text3:
            "University Mobile app developer for Ayo Kerja and Simple Chat",
        },
        {
          image: image4,
          nama: "Ian C. Mimo",
          text1: "Bachelor of Science, Mechanical and Mechatronics",
          text2: "Engineering LeTourneau University, Longview",
          text3: "Electric Wheelchair for Beeline Company in Guatemala",
        },
        {
          image: image5,
          nama: "Cavien Izack Marcelyno Satia",
          text1: "Bachelor of Science, Geology",
          text2: "University of New Hampshire, Durham",
          text3: "Advancing Papua for the education and health sectors",
        },
        {
          image: image6,
          nama: "Sabattony Watopa",
          text1: "Master of Science, Civil Engineering",
          text2: "University of Illinois at Chicago",
          text3: "UIC Research Assistant",
        },
      ],
    };
  },
  created() {
    window.addEventListener("scroll", this.windowScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
  },
  methods: {
    windowScroll() {
      const navbar = document.getElementById("navbar");
      if (
        document.body.scrollTop >= 50 ||
        document.documentElement.scrollTop >= 50
      ) {
        navbar.classList.add("nav-sticky");
      } else {
        navbar.classList.remove("nav-sticky");
      }
    },

    toggleMenu() {
      document.getElementById("topnav-menu-content").classList.toggle("show");
    },
    nextSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
    },
    prevSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    },
    countryChanged(country) {
      this.registrationPayload.country = country.iso2;
      this.registrationPayload.phone_country_code = country.dialCode;
    },

    postnumber() {
      if (this.registrationPayload.hp === "") {
        Vue.swal.fire({
          title: "",
          icon: "error",
          html: `Field must not be empty`,
          showCloseButton: false,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: "OK",
        });
        return;
      }
      axios
        .post("account/signup", {
          phone_country_code: this.registrationPayload.phone_country_code,
          phone_number: this.registrationPayload.hp,
        })
        .then((r) => {
          const { data } = r.data;
          localStorage.setItem("account", JSON.stringify(data));
          this.$router.push("registration");
        })
        .catch((err) => {
          const { data } = err.response;
          let message = "Failed to process";
          Vue.swal({
            position: "top-end",
            icon: "warning",
            title: message,
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },
  },
};
</script>

<style scoped>
#home {
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("https://api.paideia.id/api/files/public/230d122b604b41a7a8e383b1e025736asettingancoverbgcovecoders.png");
}

.hero-section {
  width: 100%;
  height: 720px;
}

.image-home {
  position: absolute;
  width: 472px;
  height: 446px;
  /* bottom: -180px; */
  z-index: 1;
  padding-right: 20px;
}

.test-image {
  position: absolute;
  width: 425px;
  height: 446px;

  bottom: -180px;
}

.hero-section .text-wrapper {
  margin-top: -30px;
}

.hero-section h1 {
  font-size: 75px;
  color: #000000;
  font-family: "PoppinsBold";
  font-style: Bold;
  line-height: 96px;
  margin-bottom: 10px;
}

.hero-section p {
  font-family: "PoppinsRegular";
  font-size: 32px;
  color: rgb(0, 0, 0);
  line-height: 48px;
  margin-bottom: 10px;
}

.hero-section .lower-text {
  font-family: "PoppinsRegular";
  font-size: 27px;
  color: rgb(0, 0, 0);
  line-height: 40.5 px;
  margin-top: -10px;
  margin-bottom: 30px;
}

.stripline {
  position: absolute;
  bottom: 235px;
  left: 34px;
  z-index: 1;
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .image-home {
    margin-bottom: -20px !important;
    width: 100%;
    height: auto;
    padding-right: 20px;
  }

  .test-image {
    width: 100%;
    height: auto;
    bottom: -100px;
  }

  .hero-section .text-wrapper {
    margin-top: -30px;
  }

  .hero-section h1 {
    font-size: 40px;
    color: #000000;
    font-family: "PoppinsBold";
    font-style: Bold;
    line-height: 46px;
    margin-bottom: 10px;
  }

  .hero-section p {
    font-family: "PoppinsRegular";
    font-size: 18px;
    color: rgb(0, 0, 0);
    line-height: 48px;
    margin-bottom: 10px;
  }

  .hero-section .lower-text {
    font-family: "PoppinsRegular";
    font-size: 18px;
    color: rgb(0, 0, 0);
    line-height: 40.5 px;
    margin-top: -10px;
    margin-bottom: 30px;
  }

  .stripline {
    position: absolute;
    width: 150px;
    height: 40px;
    bottom: 175px;
    left: 24px;
    z-index: 1;
  }

  .subscribe-form .btn-all {
    position: relative;
    padding: 0px 22px;
    left: 10px;
    font-size: 12px;
  }
}

@media (max-width: 991px) {
  .hero-section {
    width: 100%;
    height: auto;
  }

  .image-home {
    width: 100%;
    height: auto;
    padding-right: 20px;
  }

  .test {
    margin-top: -300px;
  }

  .hero-section .text-wrapper {
    margin-top: -30px;
    margin-bottom: 30px;
  }

  .hero-section h1 {
    font-size: 40px;
    color: #000000;
    font-family: "PoppinsBold";
    font-style: Bold;
    line-height: 46px;
    margin-bottom: 10px;
  }

  .hero-section p {
    font-family: "PoppinsRegular";
    font-size: 18px;
    color: rgb(0, 0, 0);
    line-height: 48px;
    margin-bottom: 10px;
  }

  .hero-section .lower-text {
    font-family: "PoppinsRegular";
    font-size: 18px;
    color: rgb(0, 0, 0);
    line-height: 40.5 px;
    margin-top: -10px;
    margin-bottom: 30px;
  }

  .stripline {
    position: absolute;
    width: 150px;
    height: 40px;
    bottom: 175px;
    left: 24px;
    z-index: 1;
  }

  .subscribe-form .btn-all {
    position: relative;
    padding: 0px 22px;
    left: 10px;
    font-size: 12px;
  }
}

@media only screen and (max-width: 700px) {
  .image-home {
    width: 100%;
    height: auto;
    margin: 140px 0px 0px 0px;
    padding-right: 20px;
  }

  .test-image {
    position: relative !important;
    width: 80%;
    height: auto;
    margin-top: -200px;
  }

  .stripline {
    width: 120px;
    height: 10px;
    left: 25px;
    top: 90px;
  }

  .test {
    margin-top: 100px;
    margin-bottom: 100px;
  }

  .hero-section {
    height: auto !important;
    width: 100%;
    margin: 50px 0px 220px 0px;
    padding: 50px 10px 0px 10px !important;
  }

  .hero-section h1 {
    font-size: 35px;
    color: #000000;
    line-height: 40px;
    margin: 0px;
  }

  .hero-section p {
    font-size: 16px;
    margin: 0px 0px 5px;
    color: #000000;
  }

  .hero-section p span {
    font-size: 14px;
    color: #000000;
  }

  .hero-section .lower-text {
    font-family: "PoppinsRegular";
    font-size: 14px;
    color: rgb(0, 0, 0);
    line-height: 40.5 px;
  }

  .hero-section .text-wrapper {
    margin-bottom: 40px;
  }
}

@media only screen and (device-width: 320px) and (orientation: portrait) {
  .hero-section .text-wrapper {
    margin-bottom: 10px !important;
  }
}
.fun-festival {
  width: 100%;
}
.after-banner {
  width: 100%;
  max-height: 611px;
  background-repeat: no-repeat;
  background-size: auto;
  background-image: url("../../../assets/images/Banner-Program.svg");
}

@media screen and (max-width: 768px) {
  .after-banner {
    width: auto;
    height: 300px;
    background-size: cover;
    margin-bottom: 70px;
  }
}

@media (max-width: 718px) {
  .after-banner {
    width: auto;
    height: 320px;
    background-size: contain;
    margin-bottom: 0px;
  }
}
.reasons-code {
}

@media (max-width: 1024px) {
  .reasons-code {
  }
}
.reasons-code .text-wrapper h2 {
  font-size: 40px;
  color: #000000;
  font-family: "PoppinsBold";
  font-style: Bold;
}

.reasons-code .text-wrapper p {
  font-family: "PoppinsRegular";
  color: #000000;
  font-size: 25px;
}

.reasons-code .wrapper-thumbnail .line1 {
  margin-top: 20px;
}

.reasons-code .wrapper-thumbnail .autop {
  margin: 30px 35px 0px 35px;
}

.reasons-code .wrapper-thumbnail .arrow {
  margin: 20px 0px 0px 0px;
}

.reasons-code .wrapper-thumbnail .autom {
  margin: 10px 0px 0px 0px;
}

.reasons-code .wrapper-thumbnail .line2 {
  margin-top: 10px;
}

.thumbnail-icon-develop {
  display: flex;
  justify-content: center;
  margin: 10px 0px 80px 0px;
}

.wrapper-thumbnail {
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  margin: 0 -15px;
  position: relative;
}

.wrapper-thumbnail::after,
.wrapper-thumbnail::before {
  position: absolute;
  content: "";
  width: 2px;
  height: 110%;
  top: 0;
  background: #d8daf3;
}

.wrapper-thumbnail::after {
  left: 67%;
}

.wrapper-thumbnail::before {
  left: 36%;
}

.thumbnail-icon::after,
.thumbnail-icon::after {
  position: absolute;
  content: "";
  width: 100%;
  height: 2px;
  background: #d8daf3;
}

.thumbnail-icon::after {
  bottom: 50%;
}

@media (max-width: 991px) {
  .wrapper-thumbnail::after {
    display: none;
  }

  .wrapper-thumbnail::before {
    display: none;
  }

  .thumbnail-icon::after {
    display: none;
  }

  .reasons-code .wrapper-thumbnail .line1 {
    margin-top: 20px;
  }

  .reasons-code .wrapper-thumbnail .autop {
    margin: 30px 45px 0px 45px;
  }

  .reasons-code .wrapper-thumbnail .aut {
    margin: 30px 30px 0px 30px;
  }

  .reasons-code .wrapper-thumbnail .arrow {
    margin: 20px 0px 0px 0px;
  }

  .reasons-code .wrapper-thumbnail .autom {
    margin: 10px 0px 0px 0px;
  }

  .reasons-code .wrapper-thumbnail .line2 {
    margin-top: 10px;
  }

  .reasons-code .wrapper-thumbnail .thumbnail-icon .thumbnail p {
    font-family: "PoppinsBold";
    color: #000000;
    font-size: 16px !important;
    text-align: center;
    padding-bottom: -50px;
  }
}

@media only screen and (max-width: 700px) {
  .wrapper-thumbnail::after {
    display: none;
  }

  .wrapper-thumbnail::before {
    display: none;
  }

  .thumbnail-icon::after {
    display: none;
  }

  .thumbnail-icon {
    margin: 15px 0px 15px 0px !important;
  }

  .thumbnail {
    margin: 30px 20px 30px 20px !important;
  }

  .reasons-code .wrapper-thumbnail .autop {
    margin: 15px 0px 0px 0px;
  }
}

.reasons-code .wrapper-thumbnail .thumbnail-icon .thumbnail p {
  font-family: "PoppinsBold";
  color: #000000;
  font-size: 22px;
  text-align: center;
  padding-bottom: -50px;
}

@media only screen and (max-width: 700px) {
  .reasons-code {
    margin-top: 50px;
  }

  .reasons-code .text-wrapper {
    margin: 0px 10px 0px 10px;
  }

  .reasons-code .text-wrapper h2 {
    font-size: 35px;
    /* line-height: 40px; */
  }

  .reasons-code .text-wrapper p {
    font-size: 18px;
  }
}

.thumbnail-icon {
  display: flex;
  justify-content: center;
  margin: 60px 0px 80px 0px;
}

@media (max-width: 425px) {
  .thumbnail-icon {
    width: 100%;
    display: inline-block;
  }
}

.thumbnail {
  text-align: center;
  margin: 0px 80px 0px 80px;
}

.thumbnail-age {
  margin: 0px 40px 0px 40px;
}

.detail-wrapper {
  text-align: center;
}

#after-reasons {
  height: 531px;
  padding: 150px 50px 0px 50px;
  margin-bottom: 100px;
}

.after-reasons {
  position: relative;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: -60px;
  /* background-image: url("https://api.paideia.id/api/files/public/20f98f42ddf3417fad3e7c003606aa75Vector4.png"); */
  background-image: url("../../../assets/images/Vector-Christomas.png");
}

.after-reasons p {
  font-family: "PoppinsRegular";
  font-size: 25px;
  color: #fff;
  line-height: 37px;
}

.after-reasons p span {
  font-family: "PoppinsBold";
  font-size: 30px;
}

.after-reasons p .pic {
  font-family: "PoppinsBold";
  font-size: 40px;
}

.after-reasons button {
  font-size: 25px;
}

@media (max-width: 991px) {
  .thumbnail {
    text-align: center;
    margin: 0px 10px 0px 10px;
  }

  .after-reasons p {
    font-size: 20px;
  }
}

.curriculum-button button {
  font-weight: 600;
  height: 63px;
  line-height: 0px;
  padding: 0;
  background: #ed4955;
  border: none;
  outline: none;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 30px;
  right: 0;
  top: 0;
  font-size: 20px;
  font-family: "PoppinsRegular";
  color: #ffffff;
  width: 216px;
}

@media only screen and (max-width: 700px) {
  #after-reasons {
    margin-bottom: 50px;
  }

  .after-reasons {
    height: auto !important;
    width: 100%;
    margin: 50px 0px 10px 0px;
    padding: 50px 10px 50px 10px !important;
    background-image: none;
    background-color: #fcd507;
  }

  .after-reasons p {
    font-size: 25px;
    /* line-height: 47px; */
  }

  .after-reasons pspan {
    font-family: "PoppinsBold";
    font-size: 30px;
  }

  .after-reasons p .pic {
    font-family: "PoppinsBold";
    font-size: 30px;
  }

  .after-reasons button {
    font-size: 20px;
  }
}

@media (max-width: 991px) {
  .after-reasons {
    height: auto !important;
    width: 100%;
    margin: 50px 0px 10px 0px;
    padding: 50px 10px 50px 10px !important;
    background-image: none;
    background-color: #fcd507;
  }
}

.develop-teach .text-wrapper h2 {
  font-size: 45px;
  color: #000000;
  font-family: "PoppinsBold";
  font-style: Bold;
  line-height: 80px;
}

.develop-teach .text-wrapper p {
  font-family: "PoppinsRegular";
  color: #000000;
  font-size: 25px;
  line-height: 40px;
}

.thumbnail-age p {
  font-size: 16px;
  margin-top: -10px;
  color: #000000;
}

@media only screen and (max-width: 700px) {
  .develop-teach .text-wrapper {
    margin: 0px 10px 0px 10px;
  }

  .develop-teach .text-wrapper h2 {
    font-size: 35px;
    line-height: 40px;
  }

  .develop-teach .text-wrapper p {
    font-size: 18px;
  }
}

@media (max-width: 991px) {
  .kiddy-people {
    margin: 95px 0px 0px 15px !important;
  }

  .junior-people {
    margin: 56px 0px 0px 0px !important;
  }

  .upper-people {
    margin: 32px 0px 0px 0px !important;
  }

  .thumbnail-age {
    margin: 0px 15px 0px 10px;
  }
}

#action {
  position: relative;
  width: 100%;
  height: 226px;
  margin-top: 110px;
  background-color: #fcd507;
}

#action .btn-all {
  position: relative;
  font-weight: 600;
  height: 60px;
  line-height: 10px;
  padding: 0px 25px 0px 25px;
  background: #ed4954;
  border: none;
  outline: none;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 42px;
  right: -10px;
  /* right: 50; */
  top: 0;
  color: #ffffff;
  /* width: auto; */
  font-size: 20px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
}

#action .subscribe-form .input-group {
  position: relative;
  margin: 75px 0px 0px 20px;
  /* geser input form */
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  width: 100%;
}

#action .subscribe-form .vti__dropdown-item .highlighted {
  background-color: #f3f3f3 !important;
}

@media (max-width: 991px) {
  .commitement-wrap {
    margin: 32px 0px 50px 0px !important;
  }

  .commitement-text {
    font-size: 35px !important;
    letter-spacing: 5px !important;
  }

  #action .subscribe-form .input-group {
    position: relative;
    margin: 75px 0px 0px 100px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    margin: 70px 60px 0px 60px;
    width: 90%;
  }

  #action .commitment-wrap .subscribe-form .btn-all {
    position: relative;
    padding: 50px 0px !important;
    left: 0px !important;
    font-size: 12px;
  }
}

@media only screen and (max-width: 700px) {
  #action {
    height: auto;
    margin: 25px 0px 25px 0px;
  }

  #action .btn-all {
    position: relative;
    padding: 0px 22px;
    font-size: 12px;
  }

  #action .subscribe-form .input-group {
    margin: 15px 0px 35px 10px;
  }
}

.font-size-1v {
  font-size: 1vw;
}

.font-size-2v {
  font-size: 2vw;
}

.font-size-3v {
  font-size: 3vw;
}

.font-size-4v {
  font-size: 4vw;
}

.font-size-5v {
  font-size: 5vw;
}

.font-size-6v {
  font-size: 6vw;
}

.commitement-wrap {
  margin: 45px 0px 40px 0px;
}

.commitement-text {
  font-size: 50px;
  letter-spacing: 18px;
}

@media only screen and (max-width: 700px) {
  .commitement-text {
    font-size: 22px;
    letter-spacing: 10px;
  }
}

.flex-footer {
  display: flex;
  justify-content: flex-start;
}

.item {
  margin-right: 20px;
  filter: saturate(8);
}

.item-without-saturate {
  margin-right: 20px;
}

.flex-footer img {
  width: 50px;
  height: 50px;
}

.subscribe-form .btn-all {
  font-weight: 600;
  height: 60px;
  line-height: 10px;
  padding: 0px 25px 0px 25px;
  background: #ed4954;
  border: none;
  outline: none;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 42px;
  right: 130px;
  top: 0;
  color: #ffffff;
  font-size: 20px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
}

.subscribe-form .vti__dropdown-item .highlighted {
  background-color: #f3f3f3 !important;
}

@media only screen and (max-width: 700px) {
  .subscribe-form .btn-all {
    position: relative;
    padding: 0px 22px;
    left: 10px;
    font-size: 12px;
  }
}

.line-bottom {
  margin-top: 120px;
}

.sosmed {
  padding: 0;
  margin-top: -5px;
}

.sosmed li {
  display: inline;
  margin-right: 15px;
}

.sosmed img {
  width: 17px;
}

#topnav-menu-content a:hover {
  font-weight: bold !important;
}

.landing-footer a:hover {
  color: #f49a3a !important;
}

@media only screen and (max-width: 700px) {
  #topnav-menu-content a:active {
    font-weight: bold !important;
  }

  .landing-footer a:active {
    color: #74cccf !important;
  }
}

footer p {
  padding: 0px 50px 0px 0px;
}

@media only screen and (max-width: 700px) {
  footer p {
    padding: 0px 0px 0px 0px;
  }
}

.vti__dropdown-list .vti__dropdown-item strong {
  color: #000;
}

.vti__dropdown-list .vti__dropdown-item span {
  color: #000;
}

.vue-tel-input {
  border-radius: 42px;
  border: none;
  background-color: #ecdfcd;
  width: 400px;
}

.vti__input {
  background-color: #ecdfcd;
  border-radius: 42px;
  height: 60px;
  border: 0px;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  color: #2b2b2b;
  padding-left: 30px;
  background: #ecdfcd;
}

.vti__input::placeholder {
  color: #8f8b8b;
}

@media only screen and (max-width: 700px) {
  .input-group {
    width: 100%;
  }
}

.landing-footer .meaning {
  font-size: 15px;
}

.kiddy-people {
  margin: 95px 0px 0px 0px;
}

.junior-people {
  margin: 56px 0px 0px 0px;
}

.upper-people {
  margin: 32px 0px 0px 0px;
}

.mb-5 {
  margin-bottom: 0rem !important;
}
.all {
  overflow: hidden;
  max-width: 1440px;
  margin: auto;
}

.head {
  display: flex;
  gap: 5px;
  justify-content: center;
  font-size: 48px;
  font-weight: bold;
  font-family: poppins;
}
@media (max-width: 1024px) {
  /* .instructur {
    margin-top: -150px;
  } */
}

@media (max-width: 768px) {
  /* .instructur {
    margin-top: -100px;
  } */
}

@media (max-width: 710px) {
  /* .instructur {
    margin-top: -100px;
  } */
  .head {
    font-size: 35px;
    display: inline;
    text-align: center;
    line-height: 40px;
  }
}

@media (max-width: 425px) {
  /* .instructur {
    margin-top: -150px;
  } */
  .head {
    font-size: 30px;
    display: inline;
    text-align: center;
    line-height: 20px;
  }
}

.head .text1 {
  color: black;
  line-height: 2.3rem;
}
.head .text2 {
  color: red;
}
.body {
  display: flex;
  width: 100%;
}

.body .content {
  margin: auto;
  grid-template-columns: repeat(2, 1fr);
  display: grid;
  gap: 0px 100px;
}

@media (max-width: 1024px) {
  .body .content {
    margin: auto;
    grid-template-columns: repeat(2, 1fr);
    display: grid;
    gap: 5px 100px;
  }
}

@media (max-width: 768px) {
  .body .content {
    margin: auto;
    grid-template-columns: repeat(2, 1fr);
    display: grid;
    gap: 5px 50px;
  }
}

@media (max-width: 660px) {
  .body .content {
    margin: auto;
    grid-template-columns: repeat(1, 1fr);
    display: grid;
  }
}

.body .grid {
  text-align: center;
  line-height: 5px;
}
.grid .image {
  border-radius: 50%;
}

.grid .isi {
  margin-top: -40px;
  color: black;
  text-align: center;
}

.isi .nama {
  color: red;
  font-size: 17px;
  font-weight: bold;
}

.isi .text3 {
  color: red;
  font-style: italic;
  line-height: 20px;
}
</style>

<template>
  <div class="all">
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <Header active-page="home"></Header>
    <div v-scroll-spy>
      <!-- hero section start -->
      <section class="section hero-section" id="home">
        <div class="container">
          <div class="row align-items-center">
            <div class="text-wrapper col-lg-8 col-md-7 col-sm-6 col-xs-6">
              <div class="text-white-50">
                <p>
                  <span class="bold"
                    >Creatively original, vibrantly engaging!</span
                  >
                </p>
                <h1>Thinking comes before coding...</h1>
                <p class="lower-text">
                  <i>at CoveCoders, it’s more than just typing!</i>
                </p>
                <img
                  class="stripline"
                  src="@/assets/images/covecoders/badge/Stripline.svg"
                  alt=""
                />
                <div class="subscribe-form input-group mb-3">
                  <vue-tel-input
                    phone_country_code="ID"
                    v-model="registrationPayload.hp"
                    style="width: 60%"
                    v-on:country-changed="countryChanged"
                    placeholder="Your phone number"
                  >
                  </vue-tel-input>
                  <button
                    type="button"
                    @click="postnumber"
                    class="btn-all w-xs"
                  >
                    Join Now
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-5 col-sm-6 col-xs-6">
              <img
                class="test-image"
                src="@/assets/images/covecoders/hero/Hero-Illustration.svg"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
      <!-- hero section end -->

      <div class="fun-festival">
        <a href="/registration">
          <!-- <section class="after-banner" id="after-banner"></section> -->
          <img src="@/assets/images/Banner-Program.svg" style="max-width:100%;"/>
        </a>
      </div>
      <div class="instructur">
        <div class="head" style="margin-top:50px;">
          <p class="text1">Our Inspirational <span class="text2">Instructors</span> </p>
        </div>
        <div class="body">
          <div class="content">
            <div class="grid" v-for="(data, index) in instructur" :key="index">
              <img :src="data.image" alt="" class="image" />
              <div class="isi">
                <p class="nama">{{ data.nama }}</p>
                <p>{{ data.text1 }}</p>
                <p>{{ data.text2 }}</p>
                <p class="text3">{{ data.text3 }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="after-reasons" id="after-reasons">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <p>Learning is fun when it has <span>significance.</span></p>
              <p>Learning must be <span>significant!</span></p>
              <p>
                Creating <span>significance,</span> however, requires
                <span>clarity and intentionality</span>
              </p>
              <p>
                in seeing the <span>big picture</span> and
                <span>connecting the dots</span> in that
              </p>
              <p><span class="pic">big picture.</span></p>
              <div class="curriculum-button">
                <a href="/curriculum"><button>Our Curriculum</button></a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="reasons-code">
        <div class="container">
          <div class="text-wrapper">
            <h2><b>6 reasons</b></h2>
            <p>why coding is important to young minds</p>
          </div>
          <div class="wrapper-thumbnail">
            <div class="row thumbnail-icon">
              <div class="thumbnail line1">
                <img src="@/assets/images/covecoders/icon/icon-1.svg" alt="" />
                <p class="autom">
                  <b>THINK <i>creatively</i></b>
                </p>
              </div>
              <div class="thumbnail line1">
                <img
                  class="arrow"
                  src="@/assets/images/covecoders/icon/icon-2.svg"
                  alt=""
                />
                <p class="autop">
                  <b>REASON <i>logically</i></b>
                </p>
              </div>
              <div class="thumbnail line1">
                <img src="@/assets/images/covecoders/icon/icon-3.svg" alt="" />
                <p class="autom">
                  <b>DESIGN <i>clearly</i></b>
                </p>
              </div>
            </div>
            <div class="row thumbnail-icon">
              <div class="thumbnail">
                <img src="@/assets/images/covecoders/icon/icon-4.svg" alt="" />
                <p class="mt-4">
                  <b>WRITE <i>intentionally</i></b>
                </p>
              </div>
              <div class="thumbnail">
                <img src="@/assets/images/covecoders/icon/icon-5.svg" alt="" />
                <p class="mt-4 aut">
                  <b>WORK <i>collaboratively</i></b>
                </p>
              </div>
              <div class="thumbnail">
                <img src="@/assets/images/covecoders/icon/icon-6.svg" alt="" />
                <p class="mt-4">
                  <b>LIVE <i>holistically</i></b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="develop-teach">
        <div class="container">
          <div class="row">
            <div class="text-wrapper">
              <h2>
                <b
                  >Developing tech leaders of tomorrow
                  <span style="color:#ED4955">TODAY</span></b
                >
              </h2>
              <p>
                Our diverse, multidisciplinary, and lively fun-based programs
                enable students to explore and discover their passion and
                God-given potential. <br />They are guided to harness their
                unique talents and grow towards human flourishing.
              </p>
            </div>
          </div>
          <!-- <div class="row thumbnail-icon-develop">
            <div class="thumbnail-age">
              <img
                class="kiddy-people"
                src="@/assets/images/covecoders/people/Vector-0.svg"
                alt=""
              />
              <div class="detail-wrapper mt-2">
                <h4 class="bold dark"><b>Kiddy</b></h4>
                <p>4-6 years old</p>
                <img
                  src="@/assets/images/covecoders/embed/embed-1.svg"
                  class="mt-4"
                  alt=""
                />
              </div>
            </div>
            <div class="thumbnail-age">
              <img
                class="junior-people"
                src="@/assets/images/covecoders/people/Vector-1.svg"
                alt=""
              />
              <div class="detail-wrapper mt-2">
                <h4 class="bold dark"><b>Junior</b></h4>
                <p>7-10 years old</p>
                <img
                  src="@/assets/images/covecoders/embed/embed-2.svg"
                  class="mt-4"
                  alt=""
                />
              </div>
            </div>
            <div class="thumbnail-age">
              <img
                class="upper-people"
                src="@/assets/images/covecoders/people/Vector-2.svg"
                alt=""
              />
              <div class="detail-wrapper mt-2">
                <h4 class="bold dark"><b>Upper</b></h4>
                <p>11-14 years old</p>
                <img
                  src="@/assets/images/covecoders/embed/embed-3.svg"
                  class="mt-4"
                  alt=""
                />
              </div>
            </div>
            <div class="thumbnail-age">
              <img
                src="@/assets/images/covecoders/people/Vector-3.svg"
                alt=""
              />
              <div class="detail-wrapper mt-2">
                <h4 class="bold dark"><b>Senior</b></h4>
                <p>15-17 years old</p>
                <img
                  src="@/assets/images/covecoders/embed/embed-4.svg"
                  class="mt-4"
                  alt=""
                />
              </div>
            </div>
          </div> -->
        </div>
      </section>

      <section id="action">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-4 col-sm-6 commitement-wrap">
              <h2 class="dark bold commitement-text">YOUR CHOICE</h2>
              <h2 class="dark bold  commitement-text">COMMITMENT</h2>
            </div>
            <div class="col-lg-6 col-md-8 col-sm-6 subscribe-form">
              <div class="input-group">
                <vue-tel-input
                  phone_country_code="ID"
                  v-model="registrationPayload.hp"
                  style="width: 60%"
                  v-on:country-changed="countryChanged"
                  placeholder="Your phone number"
                >
                </vue-tel-input>
                <button type="button" @click="postnumber" class="btn-all w-xs">
                  Join Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Footer start -->
      <Footer active-page="home"/>
      <!-- Footer end -->
    </div>
  </div>
</template>
